import React from "react";
import { useTheme } from "@emotion/react";

function ServiceCard({ title, text, Icon, size, changeStyles }) {
  const theme = useTheme();
  return (
    <div className="column service-card">
      {text && (
        <div className="inner service-card__inner">
          <div className="service-card__icon">
            <Icon size={"2.5rem"} className="icon" />
          </div>
          <div className="service-card__title">
            <h4
              style={{
                fontWeight: 600,
                fontSize: "1.1rem",
                letterSpacing: "0.02em",
                lineHeight: 1.25,
                margin: 0,
                color: `${
                  changeStyles === false
                    ? "#fff"
                    : theme.dark
                    ? "#fff"
                    : "#000000"
                }`,
              }}
            >
              {title}
            </h4>
          </div>

          <div className="service-card__text">
            {text}
          </div>
        </div>
      )}
    </div>
  );
}

export default ServiceCard;
